import React from 'react';
import CorpListContainer from './corp-list-container';

const CorpListPage = () => {
  return <CorpListContainer />;
};

export default CorpListPage;
